export const API_URL = 'https://api.hsmoa.net';
export const USER_URL = 'https://chat-user.buzzni.com';